import axiosPost from "../axiosPost";

export const SBMDocumentoPreviewGet = async (SBMDocumentoId, credentials) => {
    const body = {
        service: "SBMDocumentoPreviewGet",
        params: {
            sbmDocumentoId: SBMDocumentoId,
            merchantId: 1
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
